import { ITalkProps } from '@/entities/Talk'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface ITalkState {
  response: IResponseProps<ITalkProps>
  searched: IResponseProps<ITalkProps>
  current: ITalkProps | null
  filter: string
  saving: boolean | null
  selected: ITalkProps | null
}

export const state = (): ITalkState => ({
  response: EmptyResponsePropsFactory(),
  searched: EmptyResponsePropsFactory(),
  current: null,
  filter: 'all',
  saving: false,
  selected: null
})

export default state
